export default __webpack_public_path__ + "static/media/Flag_of_Nepal.48322e09.svg";